import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "grey--text subtitle-1" }, [
        _vm._v(_vm._s(_vm.$t("descripcion.add_base_ids"))),
      ]),
      _c(
        VCard,
        { staticClass: "mt-2", attrs: { flat: "" } },
        [
          _c(
            VForm,
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(
                VRow,
                { attrs: { dense: "" } },
                [
                  _c(
                    VCol,
                    { attrs: { cols: "3", lg: "2" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s(_vm.$t("frases.use_case"))),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "9", lg: "10" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          outlined: "",
                          "hide-details": "auto",
                          dense: "",
                          required: "",
                          readonly: "",
                          filled: "",
                          rules: _vm.rules.useCase,
                        },
                        model: {
                          value: _vm.useCase.business_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.useCase, "business_name", $$v)
                          },
                          expression: "useCase.business_name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                { staticClass: "mt-2", attrs: { dense: "" } },
                [
                  _c(
                    VCol,
                    { attrs: { cols: "3", lg: "2" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s(_vm.$t("frases.table_view"))),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "9", lg: "10" } },
                    [
                      _c(VAutocomplete, {
                        attrs: {
                          outlined: "",
                          "hide-details": "auto",
                          dense: "",
                          items: _vm.viewsData,
                          required: "",
                          "return-object": "",
                        },
                        on: { change: _vm.onTableSelected },
                        scopedSlots: _vm._u([
                          {
                            key: "append-outer",
                            fn: function () {
                              return [
                                _c(
                                  VTooltip,
                                  {
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              VIcon,
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass: "pointer",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.$refs.tablesComponent.onOpen()
                                                      },
                                                    },
                                                  },
                                                  "v-icon",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [_vm._v("mdi-layers-search")]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("frases.search_table_view")
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  VTooltip,
                                  {
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              VIcon,
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass: "pointer",
                                                    on: {
                                                      click:
                                                        _vm.getObjectAccess,
                                                    },
                                                  },
                                                  "v-icon",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [_vm._v("mdi-refresh-circle")]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("frases.update_list")) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.tableSearch,
                          callback: function ($$v) {
                            _vm.tableSearch = $$v
                          },
                          expression: "tableSearch",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                { staticClass: "mt-2", attrs: { dense: "" } },
                [
                  _c(
                    VCol,
                    { attrs: { cols: "3", lg: "2" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s(_vm.$t("frases.choose_party_id"))),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "9", lg: "10" } },
                    [
                      _c(VSelect, {
                        attrs: {
                          outlined: "",
                          "hide-details": "auto",
                          dense: "",
                          rules: _vm.rules.partyId,
                          required: "",
                          items: _vm.items,
                          "item-text": "column",
                          "item-value": "column",
                        },
                        on: { change: _vm.addPartyIdRow },
                        model: {
                          value: _vm.partyIdSelected,
                          callback: function ($$v) {
                            _vm.partyIdSelected = $$v
                          },
                          expression: "partyIdSelected",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "grey--text subtitle-1 mt-2" }, [
                _vm._v(_vm._s(_vm.$t("descripcion.select_columns"))),
              ]),
              _c(VDataTable, {
                key: _vm.keySearchTable,
                staticClass: "text-center table-inca mt-2",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.items,
                  responsive: "",
                  "show-select": "",
                  "item-key": "column",
                  "hide-default-footer": "",
                  "items-per-page": _vm.pagination.limit,
                  page: _vm.pagination.current,
                  value: _vm.columns_selected,
                },
                on: {
                  pagination: function ($event) {
                    _vm.pagination.total = $event.itemsLength
                  },
                  "update:page": function ($event) {
                    return _vm.$set(_vm.pagination, "current", $event)
                  },
                  input: _vm.updateSelected,
                },
                scopedSlots: _vm._u([
                  {
                    key: "header.data-table-select",
                    fn: function (ref) {
                      var props = ref.props
                      return [
                        _c(
                          VTooltip,
                          {
                            attrs: { attach: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        VCheckbox,
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                "input-value": _vm.allSelected,
                                                indeterminate:
                                                  _vm.indeterminate,
                                              },
                                              on: {
                                                click: _vm.toggleSelectAll,
                                              },
                                            },
                                            "v-checkbox",
                                            attrs,
                                            false
                                          ),
                                          on
                                        )
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [_c("span", [_vm._v("Select All")])]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("pagination-vue", { attrs: { pagination: _vm.pagination } }),
            ],
            1
          ),
        ],
        1
      ),
      _c("segment-tables-component", {
        ref: "tablesComponent",
        attrs: { "is-attributes": true },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }